import api from "../fapis/client";
import endpoints from "../fapis/endpoints";

// ============================================================
// HELPER: Format error message
// ============================================================
const formatErrorMessage = (error) => {
  // Network error - server is down or unreachable
  if (error.message === "Failed to fetch" || error.code === "ERR_NETWORK") {
    return "Unable to connect to the server. Please check your internet connection and try again.";
  }

  // Request timeout
  if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
    return "The request timed out. Please try again.";
  }

  // Server responded with error
  if (error.response) {
    return (
      error.response.data?.detail ||
      error.response.data?.message ||
      error.message
    );
  }

  // Fallback
  return error.message || "An unexpected error occurred. Please try again.";
};

// ============================================================
// RETAILONE (Company Users)
// ============================================================
export const loginRetailOne = async (email, password) => {
  try {
    const response = await api.post(endpoints.retailone.login, {
      email,
      password,
    });
    // console.log("Login response:", response.data);
    return {
      success: true,
      user: response.data.user,
      requires_2fa: response.data.requires_2fa || false,
      email: response.data.email || response.data.user?.email,
      session_id: response.data.session_id || null,
      val: response.data.val || null,
      features: response.data.features || [],
      permissions: response.data.permissions || [],
    };
  } catch (error) {
    console.error("Login error:", error);
    return {
      success: false,
      message: formatErrorMessage(error),
      status: error.status || 500,
    };
  }
};

export const getCurrentRetailOne = async () => {
  try {
    const response = await api.get(endpoints.retailone.me);
    return {
      success: true,
      user: response.data.user || response.data,
      features: response.data.features || [],
      permissions: response.data.permissions || [],
    };
  } catch (error) {
    console.error("Get current retailone user error:", error);
    return {
      success: false,
      message: formatErrorMessage(error),
    };
  }
};

export const logoutRetailOne = async () => {
  try {
    const response = await api.post(endpoints.retailone.logout);
    return {
      success: true,
      message: response.data?.message || "Logged out successfully",
    };
  } catch (error) {
    console.error("Logout error:", error);
    // Even if API fails, we still want to clear local state
    return {
      success: false,
      message: formatErrorMessage(error),
      status: error.status || 500,
    };
  }
};

// ============================================================
// RETAILONE OTP
// ============================================================
/*export const verifyRetailOneOTP = async (email, otp, session_id) => {
  try {
    const response = await api.post(endpoints.retailone.verifyOTP, { email, otp, session_id });
    console.log('Verify OTP response:', response.data);
    return { 
      success: true, 
      user: response.data.user,
      token: response.data.token
    };
  } catch (error) {
    console.error('Verify OTP error:', error);
    return { 
      success: false, 
      message: formatErrorMessage(error),
      status: error.status || 500
    };
  }
};*/

export const verifyRetailOneOTP = async (email, otp, session_id) => {
  try {
    const response = await api.post(endpoints.retailone.verifyOTP, {
      email,
      otp,
      session_id,
    });
    // console.log("Verify OTP response:", response.data);
    return {
      success: true,
      user: response.data.user,
      token: response.data.token,
      features: response.data.features || [],
      permissions: response.data.permissions || [],
    };
  } catch (error) {
    console.error("Verify OTP error:", error);
    return {
      success: false,
      message: formatErrorMessage(error),
      status: error.status || 500,
    };
  }
};

export const resendRetailOneOTP = async (email, session_id) => {
  try {
    const response = await api.post(endpoints.retailone.resendOTP, {
      email,
      session_id,
    });
    // console.log("Resend OTP response:", response.data);
    return {
      success: true,
      message: response.data.message,
      session_id: response.data.session_id,
    };
  } catch (error) {
    console.error("Resend OTP error:", error);
    return {
      success: false,
      message: formatErrorMessage(error),
      status: error.status || 500,
    };
  }
};

// ============================================================
// ADMIN (SBA Team)
// ============================================================
export const loginAdmin = async (email, password) => {
  try {
    const response = await api.post(endpoints.admin.login, { email, password });
    return { success: true, user: response.data.user };
  } catch (error) {
    console.error("Admin login error:", error);
    return {
      success: false,
      message: formatErrorMessage(error),
      status: error.status || 500,
    };
  }
};

export const getCurrentAdmin = async () => {
  try {
    const response = await api.get(endpoints.admin.me);
    return { success: true, user: response.data };
  } catch (error) {
    console.error("Get current admin error:", error);
    return {
      success: false,
      message: formatErrorMessage(error),
    };
  }
};

export const logoutAdmin = async () => {
  try {
    await api.post(endpoints.admin.logout);
  } catch (error) {
    console.error("Logout error:", error);
  }
};

/* import api from '../fapis/client';
import endpoints from '../fapis/endpoints';

// ============================================================
// RETAILONE (Company Users)
// ============================================================
export const loginRetailOne = async (email, password) => {
  try {
    const response = await api.post(endpoints.retailone.login, { email, password });
    console.log('Login response:', response.data);
    return { 
      success: true, 
      user: response.data.user,
      requires_2fa: response.data.requires_2fa || false,
      email: response.data.email || response.data.user?.email,
      session_id: response.data.session_id || null
    };
  } catch (error) {
    console.error('Login error:', error);
    return { success: false, message: error.message };
  }
};

export const getCurrentRetailOne = async () => {
  try {
    const response = await api.get(endpoints.retailone.me);
    return { success: true, user: response.data };
  } catch (error) {
    return { success: false };
  }
};

export const logoutRetailOne = async () => {
  try {
    await api.post(endpoints.retailone.logout);
  } catch (error) {
    console.error('Logout error:', error);
  }
};

// ============================================================
// RETAILONE OTP
// ============================================================
export const verifyRetailOneOTP = async (email, otp, session_id) => {
  try {
    const response = await api.post(endpoints.retailone.verifyOTP, { email, otp, session_id });
    console.log('Verify OTP response:', response.data);
    return { 
      success: true, 
      user: response.data.user,
      token: response.data.token
    };
  } catch (error) {
    console.error('Verify OTP error:', error);
    return { 
      success: false, 
      message: error.message,
      status: error.status,
      error: error.data?.detail || error.message 
    };
  }
};

export const resendRetailOneOTP = async (email, session_id) => {
  try {
    const response = await api.post(endpoints.retailone.resendOTP, { email, session_id });
    console.log('Resend OTP response:', response.data);
    return { 
      success: true,
      message: response.data.message,
      session_id: response.data.session_id
    };
  } catch (error) {
    console.error('Resend OTP error:', error);
    return { 
      success: false, 
      message: error.message,
      status: error.status,
      error: error.data?.detail || error.message 
    };
  }
};

// ============================================================
// ADMIN (SBA Team)
// ============================================================
export const loginAdmin = async (email, password) => {
  try {
    const response = await api.post(endpoints.admin.login, { email, password });
    return { success: true, user: response.data.user };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getCurrentAdmin = async () => {
  try {
    const response = await api.get(endpoints.admin.me);
    return { success: true, user: response.data };
  } catch (error) {
    return { success: false };
  }
};

export const logoutAdmin = async () => {
  try {
    await api.post(endpoints.admin.logout);
  } catch (error) {
    console.error('Logout error:', error);
  }
}; */
